import type { RefObject } from 'react';
import { createContext } from 'react';

type SidePanelToggleContextValue = {
  isOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
};

export const SidePanelToggleContext = createContext<SidePanelToggleContextValue>({
  isOpen: false,
  openPanel: () => undefined,
  closePanel: () => undefined,
});

export const SidePanelHeightAnchorRefContext = createContext<RefObject<HTMLElement> | undefined>(undefined);

// `MainArea` (see Layout.tsx) measures how far its own right edge sits from the viewport's
// right edge and provides the result here — 0 when nothing is eating into that space, and
// growing only when the side panel actually opens and shrinks it. Consumers add this to
// whatever base gutter their own stylesheet already uses (e.g. `right: calc(10px + var(--x))`)
// rather than the offset itself owning or duplicating that default.
export const MainAreaRightShiftContext = createContext<number>(0);
